export function initSeoRecommended() {
    var section = document.querySelector('[data-seo-add-to-channel]');
    if (!section) return;
    var channelId = parseInt(section.getAttribute('data-seo-add-to-channel'), 10);
    var btn = section.querySelector('.seo-add-to-channel-btn');
    var resultEl = section.querySelector('.seo-add-result');
    var selectAll = section.querySelector('.seo-select-all');
    var checkboxes = section.querySelectorAll('.seo-phrase-cb');
    if (!btn || !resultEl || !selectAll) return;

    function updateButtonState() { var n = section.querySelectorAll('.seo-phrase-cb:checked').length; btn.disabled = n === 0; }
    function updateSelectAll() { var total = checkboxes.length; var checked = section.querySelectorAll('.seo-phrase-cb:checked').length; selectAll.checked = total > 0 && checked === total; selectAll.indeterminate = checked > 0 && checked < total; }

    selectAll.addEventListener('change', function() { checkboxes.forEach(function(cb) { cb.checked = selectAll.checked; }); updateButtonState(); });
    checkboxes.forEach(function(cb) { cb.addEventListener('change', function() { updateButtonState(); updateSelectAll(); }); });

    btn.addEventListener('click', function() {
        var phrases = [];
        section.querySelectorAll('.seo-phrase-cb:checked').forEach(function(cb) { var v = (cb.getAttribute('data-phrase') || cb.value || '').trim(); if (v) phrases.push(v); });
        if (phrases.length === 0) return;
        btn.disabled = true;
        resultEl.textContent = 'Добавляем…';
        fetch('/api/seo/recommended/add-to-channel', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-Token': window.getCsrfToken() },
            body: JSON.stringify({ channel_id: channelId, phrases: phrases })
        })
        .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, status: r.status, data: data }; }); })
        .then(function(res) {
            if (res.ok && res.data.success) {
                resultEl.textContent = 'Добавлено: ' + res.data.added + (res.data.skipped > 0 ? ', уже в канале: ' + res.data.skipped : '') + '.';
                if (res.data.added > 0) { setTimeout(function() { window.location.reload(); }, 1200); }
                else { section.querySelectorAll('.seo-phrase-cb:checked').forEach(function(cb) { cb.checked = false; }); updateSelectAll(); updateButtonState(); }
            } else { resultEl.textContent = res.data.error || res.data.message || 'Ошибка'; }
        })
        .catch(function() { resultEl.textContent = 'Ошибка сети'; })
        .finally(function() { btn.disabled = false; });
    });

    var askFedorBtn = section.querySelector('.seo-ask-fedor-btn');
    var fedorAnswerEl = section.querySelector('.seo-fedor-answer');
    if (askFedorBtn && fedorAnswerEl) {
        var phrasesData = section.getAttribute('data-seo-ask-fedor-phrases');
        var phrases = [];
        try { if (phrasesData) phrases = JSON.parse(phrasesData); } catch (e) {}
        askFedorBtn.addEventListener('click', function() {
            if (phrases.length === 0) return;
            askFedorBtn.disabled = true;
            var bodyEl = fedorAnswerEl.querySelector('.seo-fedor-answer-body');
            var linkEl = fedorAnswerEl.querySelector('.seo-fedor-answer-link');
            if (linkEl) linkEl.classList.add('hidden');
            if (bodyEl) bodyEl.textContent = 'Фёдор думает…';
            fedorAnswerEl.classList.remove('hidden');
            fetch('/api/seo/recommended/ask-fedor', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest', 'X-CSRF-Token': window.getCsrfToken() },
                body: JSON.stringify({ phrases: phrases })
            })
            .then(function(r) { return r.json().then(function(data) { return { ok: r.ok, data: data }; }); })
            .then(function(res) {
                var bodyEl2 = fedorAnswerEl.querySelector('.seo-fedor-answer-body');
                var linkEl2 = fedorAnswerEl.querySelector('.seo-fedor-answer-link');
                if (res.ok && res.data.answer) { if (bodyEl2) bodyEl2.textContent = res.data.answer; if (linkEl2) linkEl2.classList.remove('hidden'); }
                else { if (bodyEl2) bodyEl2.textContent = res.data.error || 'Ошибка'; if (linkEl2) linkEl2.classList.add('hidden'); }
            })
            .catch(function() { var b = fedorAnswerEl.querySelector('.seo-fedor-answer-body'); if (b) b.textContent = 'Ошибка сети'; })
            .finally(function() { askFedorBtn.disabled = false; });
        });
    }
}
